var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleHistory = function SvgCircleHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#DDDBFF",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 0.25,
    d: "M14.745 7a8.02 8.02 0 0 0-7.24 4.588l-.301-.986a.616.616 0 1 0-1.177.355l.753 2.48a.616.616 0 0 0 .75.413l2.431-.663a.616.616 0 0 0-.323-1.19l-1.104.303a6.77 6.77 0 0 1 6.211-4.07A6.757 6.757 0 0 1 21.514 15a6.76 6.76 0 0 1-6.769 6.77 6.77 6.77 0 0 1-6.547-5.03.616.616 0 0 0-1.19.314A8.01 8.01 0 0 0 14.745 23c4.413 0 8-3.59 8-8 0-4.412-3.588-8-8-8Zm-.405 3.86a.616.616 0 0 0-.613.614v4.534a.62.62 0 0 0 .309.536l2.885 1.64a.615.615 0 0 0 .898-.7.61.61 0 0 0-.29-.372l-2.571-1.462v-4.176a.615.615 0 0 0-.618-.613Z",
    clipRule: "evenodd"
  })));
};
export default SvgCircleHistory;